export var VERSION = "1.3.29";
//# sourceMappingURL=version.js.map